import pick from 'lodash/fp/pick';
import pickBy from 'lodash/pickBy';

import config from '@config';

import { getDefaultEmptyList, getDefaultListHandler } from '../utils';
import createDataSource from '../createDataSource';

import { BOOK_FILTER_FIELD } from './constants';

const BASE_PATHNAME = 'chapters';

export default () => {
  const dataSource = createDataSource(`${config.api.url}`);

  const getById = ({ id, locale }) => dataSource.get(`${BASE_PATHNAME}/${id}/${locale}`).json();
  const getByIds = ({ ids }) => Promise.all(ids.map((id) => getById({ id })));

  const remove = ({ id }) => dataSource.delete(`${BASE_PATHNAME}/${id}`);

  const create = ({ values: json }) => dataSource.post(BASE_PATHNAME, { json }).json();
  const update = ({ id, locale, values }) =>
    dataSource.put(`${BASE_PATHNAME}/${locale}`, { json: { ...values, id } }).json();

  const publish = async ({ id, values, locale, dateTime }) => {
    const chapter = await (id ? update({ id, values, locale }) : create({ values }));
    return dataSource
      .put(`${BASE_PATHNAME}/${chapter.id}/${locale}/publish`, { searchParams: pickBy({ dateTime }) })
      .json();
  };

  const unpublish = ({ id, locale }) => dataSource.put(`${BASE_PATHNAME}/${id}/${locale}/unpublish`).json();

  const duplicate = ({ id }) => dataSource.post(`${BASE_PATHNAME}/${id}/duplicate`).json();

  return {
    getList: getDefaultListHandler({
      url: BASE_PATHNAME,
      dataSource,
      transformFilter: pick([BOOK_FILTER_FIELD]),
    }),

    getById,

    getByIds,

    remove,

    create,

    update,

    publish,

    unpublish,

    duplicate,

    getEmptyList: getDefaultEmptyList,
  };
};
